import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import businessDashboardLicenses from './businessDashboardLicenses.json';
import commonLicenses from './commonsLicenses.json';
import styles from './DashboardFrontendLisenses.module.scss';
import initAppLicenses from './initAppLicenses.json';

type Licence = {
    name: string;
    licenseType: string;
    link: string;
    installedVersion: string;
    author: string;
};
// to generate the list of licenses, run the following command from the same folder as the package.json file:
// license-report --only=prod --fields=name --fields=licenseType --fields=link --fields=installedVersion --fields=author

const AirthingsLibs = ['consumer-dashboard', 'business-dashboard', 'commons', 'init-app', 'iaq-public-dashboard'];
const DashboardFrontendLicenses = (): ReactElement => {
    const { t: txt } = useTranslation();
    const licences = [...commonLicenses, ...businessDashboardLicenses, ...initAppLicenses];
    const uniqueLicenses = licences.reduce((acc: Record<string, Licence>, license: Licence) => {
        if (AirthingsLibs.includes(license.name)) {
            return acc; // Skip libraries owned by Airthings
        }
        if (!acc[license.name]) {
            acc[license.name] = license;
        }
        return acc;
    }, {});

    const getUrl = (link: string): string => {
        const gitPrefix = 'git+';
        return link.startsWith(gitPrefix) ? link.substring(gitPrefix.length) : link;
    };

    return (
        <div>
            <h1>{txt('SwLicense.BusinessDashboardLicenseHeader')}</h1>
            <p>{txt('SwLicense.BusinessDashboardLicenseDescription')}</p>
            <div className={styles.wrapper}>
                {Object.values(uniqueLicenses).map((license: Licence) => (
                    <div key={license.name}>
                        <div className={styles.header}>{license.name}</div>
                        <div>
                            {txt('SwLicense.InstalledVersion')}: {license.installedVersion}
                        </div>
                        <div>License type: {license.licenseType}</div>
                        <div>
                            {txt('SwLicense.License')}:{' '}
                            <a href={getUrl(license.link)} rel="noopener noreferrer" target="_blank">
                                {getUrl(license.link)}
                            </a>
                        </div>
                        <div>
                            {txt('SwLicense.Author')}: {license.author}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DashboardFrontendLicenses;
